<template>
  <div>
    <pop-modal :visible="visible" title="客户编码" :width="width" :height="height" @cancel="handelCancel">
      <div class="main-content">
        <div class="left-cont">
          <div class="left-edit">
            <div><img src="@/assets/add.png" />增加</div>
            <div><img src="@/assets/edit.png" />修改</div>
            <div><img src="@/assets/delete.png" />删除</div>
          </div>
          <div class="category">
            <a-tree show-line :default-expanded-keys="['0-0-0']">
              <a-icon slot="switcherIcon" type="down" />
              <a-tree-node key="0-0" title="客户类别">
                <a-tree-node key="0-0-0" title="自动保存" />
              </a-tree-node>
            </a-tree>
          </div>
        </div>
        <div class="right-cont">
          <div class="export-import" v-if="!isModule">
            <a-button type="primary" ghost> 导入 </a-button>
            <a-button type="primary" ghost> 导出 </a-button>
          </div>
          <div class="option-btn">
            <div class="edit-group">
              <a-button type="primary" ghost @click="editKehu('add')"> 增加 </a-button>
              <a-button type="primary" ghost @click="editKehu('edit')"> 修改 </a-button>
              <a-button type="primary" ghost @click="deletKehu()"> 删除 </a-button>
            </div>
            <div class="search">
              <a-input
                v-model="kehuCode"
                placeholder="请输入客户编码、名称、税号等信息"
                @pressEnter="search()"
                @change="search()"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
              <a-button type="primary" @click="search()"> 搜索 </a-button>
              <a-button type="primary" @click="onSelect()" v-if="isModule"> 选择 </a-button>
            </div>
          </div>
          <m-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              onDbClick: isModule && onDbClick,
            }"
            :columns="columns"
            :data-source="listOfData"
            :pages="pages"
            @pro="pro()"
            @next="next()"
            @changeShowCount="changeShowCount"
          ></m-table>
        </div>
      </div>
    </pop-modal>
    <!-- 编辑客户编码 -->
    <pop-modal width="750px" :height="70" :isDrag="true" :title="'客户编码' + modalType" :visible="isEdit" @cancel="cancelForm()">
      <div style="padding: 12px 24px">
        <a-form labelAlign="left">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="kehu.name"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="kehu.code"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="客户税号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="kehu.taxPayerId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="简码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="kehu.shortName"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="邮件地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="kehu.mailAddr"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item
                label="地址电话"
                :labelCol="{
                  xs: { span: 24 },
                  sm: { span: 4 },
                }"
                :wrapperCol="wrapperCol"
              >
                <a-input type="textarea" v-model="kehu.address"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item
                label="银行账号"
                :labelCol="{
                  xs: { span: 24 },
                  sm: { span: 4 },
                }"
                :wrapperCol="wrapperCol"
              >
                <a-input type="textarea" v-model="kehu.accounts"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="kehu.remark"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <div style="visible: none; height: 53px"></div>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'center',
              zIndex: 1,
            }"
          >
            <a-button style="margin: 0 20px" type="primary" @click="submitFrom()" :loading="submitLoad">保存</a-button>
            <a-button style="margin: 0 20px" type="primary" @click="cancelForm()">取消</a-button>
          </div>
        </a-form>
      </div>
    </pop-modal>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, searchData } from '@/utils/util.js'
const defaultPages = {
  id: '',
  name: '',
  code: '',
  taxPayerId: '',
  shortName: '',
  mailAddr: '',
  address: '',
  accounts: '',
  remark: '',
}
export default {
  props: {
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: 100,
    },
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      isEdit: false,
      value: '',
      selectedRowKeys: [],
      columns: [
        {
          title: '编码',
          dataIndex: 'code',
          width: 80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 150,
        },
        {
          title: '简码',
          dataIndex: 'shortName',
          width: 150,
        },
        {
          title: '税号',
          dataIndex: 'taxPayerId',
          width: 150,
        },
        {
          title: '地址电话',
          dataIndex: 'address',
          width: 150,
        },
        {
          title: '银行账号',
          dataIndex: 'accounts',
          width: 150,
        },
        {
          title: '邮件地址',
          dataIndex: 'mailAddr',
          width: 150,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
        },
      ],
      pages: {
        total: 0,
        pageIndex: 1,
        totalPage: 0,
        showCount: 10,
        currentPage: 1,
        index: -1,
      },
      listOfData: [],
      maxCode: -1,
      kehuCode: '',
      // 客户编码新增编辑
      kehu: {
        id: '',
        name: '',
        code: '',
        taxPayerId: '',
        shortName: '',
        mailAddr: '',
        address: '',
        accounts: '',
        remark: '',
      },
      isModule: false,
      submitLoad: false,
      modalType: '添加',
    }
  },
  created() {},
  methods: {
    show(module) {
      this.isModule = !!module
      this.visible = true
      this.getCustomList()
    },
    async getCustomList() {
      let params = parseParam({
        showCount: this.pages.showCount,
        currentPage: this.pages.currentPage,
      })
      if (this.kehuCode) {
        params = parseParam(searchData(this.kehuCode))
      }
      const res = await this.$http.get(`${Urls.getCustomList}&${params}`)
      if (res.statusCode === '200') {
        this.listOfData = res.data
        this.pages.total = res.total
        this.pages.totalPage = res.totalPage
        this.maxCode = res.total
      }
    },
    handelCancel() {
      this.visible = false
    },
    initCustomNo() {
      this.kehuCode = ''
      this.pages = JSON.parse(JSON.stringify(defaultPages))
    },
    search() {
      this.getCustomList()
    },
    pro() {
      if (this.pages.currentPage > 1) {
        this.pages.currentPage--
        this.getCustomList()
      }
    },
    next() {
      if (this.pages.currentPage < this.pages.totalPage) {
        this.pages.currentPage++
        this.getCustomList()
      }
    },
    changeShowCount(val) {
      this.pages.showCount = val
      this.pages.currentPage = 1
      this.getCustomList()
    },
    editKehu(type) {
      if (type === 'edit') {
        this.modalType = '编辑'
        if (!this.selectedRowKeys.length) {
          this.$notification['warning']({
            message: '请选择一行进行修改',
          })
          return false
        }
        this.getKehu()
      } else if (type === 'add') {
        this.modalType = '添加'
        this.initKehu()
      }
      this.isEdit = true
    },
    getKehu() {
      this.kehu = JSON.parse(JSON.stringify(this.selectedRowKeys[0]))
    },
    initKehu() {
      for (const key in this.kehu) {
        this.kehu[key] = ''
      }
    },
    deletKehu() {
      if (!this.selectedRowKeys.length) {
        this.$notification['warning']({
          message: '请选择一行进行删除！',
        })
        return false
      }
      this.$confirm({
        title: '信息',
        content: '删除将不可恢复。确定删除?',
        onOk: async () => {
          const params = parseParam({
            id: this.selectedRowKeys[0].id,
          })
          const res = await this.$http.post(`${Urls.deleteCustom}&${params}`)
          if (res.statusCode === '200') {
            this.getCustomList()
            this.$message.success('删除成功')
          }
        },
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelect() {
      this.$emit('emitRowKey', this.selectedRowKeys)
    },
    onDbClick(selectedRowKeys) {
      this.$emit('emitRowKey', selectedRowKeys)
    },
    async submitFrom() {
      const type = this.kehu.id ? 'edit' : 'add'
      // 后端保存的时候格式化前端goo对象
      if (!this.kehu.name) {
        this.$notification['warning']({
          message: '客户名称不能为空!',
        })
        return
      }
      if (this.kehu.taxPayerId.length < 15) {
        this.$warning({
          title: '提示',
          content: '税号不符合校验规则',
        })
        return
      }
      const params = parseParam({
        data: JSON.stringify(this.kehu),
      })
      this.submitLoad = true
      const res = await this.$http.post(`${Urls.saveCustom}&${params}`)
      if (res.statusCode === '200') {
        await this.getCustomList()
        let content = ''
        if (type === 'edit') {
          content = '修改成功!'
        } else {
          content = '新增成功!'
        }
        this.$message.success(content)
      }
      this.cancelForm()
      this.isEdit = false
    },
    cancelForm() {
      this.isEdit = false
      this.submitLoad = false
      this.initKehu()
    },
  },
}
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  height: 100%;
  .left-cont {
    width: 20%;
    background-color: #e8f5ff;
    height: 100%;
    min-width: 200px;
  }
  .right-cont {
    flex: 1;
    padding: 10px 10px 20px 10px;
    overflow: auto;
    .export-import {
      text-align: right;
      button {
        &:last-child {
          margin-left: 20px;
        }
      }
    }
    .option-btn {
      display: flex;
      justify-content: space-between;
      margin: 15px 0;
      .edit-group {
        button {
          margin-right: 10px;
        }
      }
      .search {
        display: flex;
        button {
          margin-left: 10px;
        }
      }
    }
  }
}
.left-cont {
  .left-edit {
    height: 50px;
    background-color: #d2ebff;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
